export default function apostrophe(name: string) {
  if (!name) {
    return "";
  }
  if (/s$/i.test(name)) {
    return `${name}'`;
  }
  {
    return `${name}'s`;
  }
}
